import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, throwError as observableThrowError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { ConfigurationService } from '../core/configuration.service';

@Injectable({
  providedIn: 'root'
})
export class CustomerConsentService {
    private baseApiUrl: string;

    constructor(configurationService: ConfigurationService, private httpClient: HttpClient) {
        this.baseApiUrl = configurationService.BaseApiUrl;
    }

    getById(id: number, forMaintenance: boolean = false): Observable<any> {
        return this.httpClient.get(this.baseApiUrl + `customerconsent/${id}?isMaintenance=${forMaintenance}`).pipe(
            map((res: any) => res),
            catchError((err: any) => observableThrowError(err.message || 'Server error')));
    }

    getForCustomer(customerId: number): Observable<any> {
        return this.httpClient.get(this.baseApiUrl + `customerconsent/customer/${customerId}`).pipe(
            map((res: any) => res),
            catchError((err: any) => observableThrowError(err.message || 'Server error')));
    }

    check(customerId: number, consentTypeId: number): Observable<any> {
        return this.httpClient.get(this.baseApiUrl + `customerconsent/check?customerId=${customerId}&consentTypeId=${consentTypeId}`).pipe(
            map((res: any) => res),
            catchError((err: any) => observableThrowError(err.message || 'Server error')));
    }

    getFiltered(filter: string, pageIndex: number, pageSize: number,
        sortColumn: string, sortAscending: boolean, isMaintenance: boolean = true): Observable<any> {
        const params = { filter, pageIndex, pageSize, sortColumn, sortAscending, isMaintenance };
        return this.httpClient.post(this.baseApiUrl + 'customerconsent/filter', params).pipe(
            map((res: any) => res),
            catchError((err: any) => observableThrowError(err.message || 'Server error')));
    }

    grant(consent: any): Observable<any> {
        return this.httpClient.post(this.baseApiUrl + 'customerconsent/grant', consent).pipe(
            map((res: any) => res),
            catchError((err: any) => observableThrowError(err.message || 'Server error')));
    }

    renew(id: number, validityDays?: number): Observable<any> {
        return this.httpClient.post(this.baseApiUrl + 'customerconsent/renew', { id, validityDays }).pipe(
            map((res: any) => res),
            catchError((err: any) => observableThrowError(err.message || 'Server error')));
    }

    revoke(id: number, reason: string): Observable<any> {
        return this.httpClient.post(this.baseApiUrl + 'customerconsent/revoke', { id, reason }).pipe(
            map((res: any) => res),
            catchError((err: any) => observableThrowError(err.message || 'Server error')));
    }

    authorise(id: number): Observable<any> {
        return this.httpClient.post(this.baseApiUrl + 'customerconsent/authorise', id).pipe(
            map((res: any) => res),
            catchError((err: any) => observableThrowError(err.message || 'Server error')));
    }
}
